<template>
  <v-file-input
    class="my-10"
    prepend-icon="mdi-folder-multiple-image"
    accept="audio/*, video/*, image/*"
    ref="file"
    @change="uploadFiles"
    :loading="loading"
    :label="$t('inspectionProfile.fileInput')"
    outlined
    dense
  ></v-file-input>
</template>

<script>
import { storage } from "@/plugins/db";
export default {
  props: ["uid"],
  data: () => ({
    i: 0,
    progressUpload: 0,
    uploadTask: "",
    uploading: false,
    uploadEnd: false,
    loading: false,
    downloadURL: "",
    success: false
  }),
  methods: {
    async uploadFiles(file) {
      let folder = file.type.split("/");
      this.loading = true;
      await storage
        .ref(
          `inspections/${this.uid}/${folder[0]}/${this.withoutSpaces(
            file.name
          )}`
        )
        .put(file)
        .then(snapshot => {
          snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$emit("done", downloadURL);
          });
        });
      this.loading = false;
      this.$dialog.notify.success(
        this.$t("notifications.success.inspectionProfile.multimediaUpload"),
        {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-paperclip"
        }
      );
    },
    withoutSpaces(str) {
      const nameArray = str.split(" ");
      return nameArray.join("");
    }
  }
};
</script>
